import React from 'react'
import { ChevronArrowDown } from 'newComponents'
import './styles.scss'

const TextButtonWithDropdownArrow = ({ to, onClick, text }) => (
  <div className="has-text-centered-tablet">
    {to ? (
      <a href={to} onClick={onClick} className="cta text-button-dropdown-arrow" role="button" tabIndex="0">
        {text} <ChevronArrowDown />
      </a>
    ) : (
      <div onClick={onClick} className="cta text-button-dropdown-arrow" role="button" tabIndex="0">
        {text} <ChevronArrowDown />
      </div>
    )}
  </div>
)

export default TextButtonWithDropdownArrow
